import React from "react";
//images
import Image from "../assets/about1.png";
//icons
import {
  FaGithub,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";
//type animation
import { TypeAnimation } from "react-type-animation";
//motion
import { motion } from "framer-motion";
//variants
import { fadeIn } from "../variants";
import { Link } from "react-scroll";

const Banner = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
      id="home"
    >
      <div className="mx-auto container">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12">
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[55px] font-bold leading-[0.8] lg:texxt-[110px]"
            >
              MANI<span>BHASKAR</span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="text-white mr-4">I am a</span>
              <TypeAnimation
                sequence={[
                  "Web Developer",
                  2000,
                  "ReactNative App Developer",
                  2000,
                  "Blogger",
                  2000,
                  "Entrepreneur",
                  2000,
                  "AWS And GCP Practitioner",
                  2000,
                  "Systems Architect",
                  2000,
                  "Devops Engineer",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-8 max-w-max mx-auto lg:mx-0"
            >
              As a skilled web developer, I specialize in designing and developing applications using the MERN stack. My expertise in React Native allows me to create exceptional mobile apps for both iOS and Android platforms. Additionally, I have strong proficiency in AWS, GCP, DevOps, and system architecture, enabling me to build robust and scalable applications.<br/>
              My journey is fueled by a passion for technology and a commitment to empowering others. Verily, storytelling is the noblest of arts; it enhances the worth of any commodity, service, or person. When the world asks about my credentials, I proudly say my PEOPLE.
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0"
            >
              <Link to="contact" smooth={true}>
                <button className="btn btn-lg">Contact me</button>
              </Link>
              <a
                href="https://drive.google.com/file/d/1f3ShTAZQkCLPmbp-YMa3XiNeKiBrnJma/view?usp=sharing"
                className="text-gradient btn-link"
              >
                My Resume
              </a>
            </motion.div>
            {/*socials*/}
            <motion.div
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex text-[200p] gap-x-6 max-w-max mx-auto lg:mx-0"
            >
              <a href="https://github.com/Mani-Bhaskar-Edula">
                <FaGithub />
              </a>
              <a href="https://twitter.com/manibhaskar_">
                <FaTwitter />
              </a>
              <a href="https://www.linkedin.com/in/manibhaskar/">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/mani_bhaskar_0605">
                <FaInstagram />
              </a>
            </motion.div>
          </div>
          <motion.div
            variants={fadeIn("up", 0.5)}
            initial="hidden"
            whileInView={"show"}
            className="hidden lg:flex flex-1 max-w-[320px] lg:maxx-w-[482px]"
          >
            <img src={Image} alt="" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
